import { RequestPayload } from "appworks/model/gameplay/requests/request-payload";

export class HistoryRequestPayload extends RequestPayload {
    constructor(public id: string) {
        super();
    }
}
